import React from 'react'
import NotFound404 from '../components/404'
function CareerPage  ()  {
  return (
    <div>
      <NotFound404 />
    </div>
  )
}

export default CareerPage
